let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cTw4k")).then(() => parcelRequire('2KZY1'));